import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {Field, Form} from "react-final-form";
import {classNames} from "primereact/utils";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";
import Cookies from "js-cookie";


const NotificationFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [registrations, setRegistrations] = useState([]);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    const payload = {
      registration: formData.registration || null,
      title_en: formData.title_en || "",
      title_hu: formData.title_hu || "",
      message_en: formData.message_en || "",
      message_hu: formData.message_hu || "",
      isGlobal: !!formData.isGlobal,
      urgent: !!formData.urgent,
      targetRole: formData.isGlobal ? null : (formData.targetRole || null),
      targetUser: formData.isGlobal ? null : (formData.targetUser || null),
      link: formData.link || null
    };
    setLoading(true)
    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/notification",
      payload,
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        setFormData(response.data.data)
        setLoading(false)
        window.App.toastShow('success', t('success'), response.data.message)
        window.App.setState({
          rerenderNotificationList: Math.random(),
        })
        if (props.closeForm === true) {
          navigate(-1)
        }
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
      })
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };
  useEffect(() => {
    document.title = t('notifications') + ' - ' + process.env.REACT_APP_TITLE;
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/user-registration",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setRegistrations(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "user/roles",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        let _roles = []
        Object.entries(response.data.data).map(([key,value]) => (
          _roles.push({key:key,value:value})
        ))
        setRoles(_roles)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, []);

  useEffect(() => {
    if(formData.registration) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "user",
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": formData.registration,
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setUsers(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.registration]);

  return (
    <>
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit}) => (
        <form onSubmit={handleSubmit} className="">
          <Panel>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                <h2 className={"p-m-0"}>{t('notification_send')}</h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                <Button type="submit" aria-label={t('save_and_close')}
                        loading={loading}
                        onClick={() => {
                          props = {...props, closeForm: true}
                        }}
                        className="p-button-success p-ml-2">
                      <span>
                        <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                      </span>
                </Button>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <Field name="title_en" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="title_en"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('title')} (EN)</label>
                    <span className="p-d-block">
                      <InputText id="title_en" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     title_en: e.target.value
                                   })
                                 }}
                                 value={formData.title_en}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12"}>
                <Field name="title_hu" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="title_hu"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('title')} (HU)</label>
                    <span className="p-d-block">
                      <InputText id="title_hu" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     title_hu: e.target.value
                                   })
                                 }}
                                 value={formData.title_hu}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12"}>
                <Field name="message_en" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="message_en"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('message')} (EN)</label>
                    <span className="p-d-block">
                      <InputText id="message_en" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     message_en: e.target.value
                                   })
                                 }}
                                 value={formData.message_en}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12"}>
                <Field name="message_hu" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="message_hu"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('message')} (HU)</label>
                    <span className="p-d-block">
                      <InputText id="message_hu" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     message_hu: e.target.value
                                   })
                                 }}
                                 value={formData.message_hu}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12"}>
                <Field name="link" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="link"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('link')}</label>
                    <span className="p-d-block">
                      <InputText id="link" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     link: e.target.value
                                   })
                                 }}
                                 value={formData.link}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="registration" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="registration"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('registration')}</label>
                    <span className="p-d-block">
                      <Dropdown  options={registrations}
                                filter
                                optionLabel="system_name"
                                optionValue="system_name_slugged"
                                id={"registration"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    registration: e.target.value,
                                    targetRole: null,
                                    targetUser: null,
                                    isGlobal: false,
                                  })
                                }}
                                value={formData.registration}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="user" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="user"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('user')}</label>
                    <span className="p-d-block">
                      <Dropdown  options={users}
                                disabled={!formData.registration}
                                filter
                                optionLabel="email"
                                optionValue="id"
                                id={"user"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    targetUser: e.target.value,
                                    targetRole: null,
                                    isGlobal: false
                                  })
                                }}
                                value={formData.targetUser}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="targetRole" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="targetRole"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('role')}</label>
                    <span className="p-d-block">
                      <Dropdown  options={roles}
                                filter
                                optionLabel="value"
                                optionValue="value"
                                id={"targetRole"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    targetRole: e.target.value,
                                    targetUser: null,
                                    isGlobal: false
                                  })
                                }}
                                value={formData.targetRole}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="isGlobal" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="isGlobal"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('isGlobal')}</label>
                    <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"isGlobal"}
                        checked={formData.isGlobal}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            targetRole: null,
                            targetUser: null,
                            isGlobal: e.value
                          })
                        }}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="urgent" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="urgent"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('urgent')}</label>
                    <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"urgent"}
                        checked={formData.urgent}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            urgent: e.value
                          })
                        }}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
          </Panel>
        </form>
      )}/>
    </>
  )
}
export default withTranslation('common')(NotificationFormComponent);
